<template>
  <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span class="text-center">Lead Assigned</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="DailyUpdateSetup">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                v-model="employee_id.value.value"
                :items="getHrmEmployeeList"
                :item-title="(item) => `${item.name}`"
                item-value="id"
                :error-messages="employee_id.errorMessage.value"
                autocomplete="off"
                multiple
                chips
                clearable
              >
                <template #label>
                  Employees
                  <span class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>

              <v-checkbox
                label="Active"
                v-model="status.value.value"
                :error-messages="status.errorMessage.value"
                density="compact"
                variant="outlined"
                hide-details
                single-line
                color="primary"
                value="1"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn
                class="bg-red"
                variant="flat"
                type="reset"
                @click="closeDialog"
                >Close</v-btn
              >
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                {{ isEntryMode ? "Save" : "Update" }}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";

export default {
  name: "EmployeeUpdateSetup",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        status: "1",
      }),
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: "",
      loading: false,
      isEntryMode: true,
    };
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    data: {
      handler(newData) {
        console.log(newData.id);
        this.isEntryMode = !newData.id;
        // this.resetForm({ errors: {}, touched: {} });
        this.status.setValue(String(newData.status) || "1", false);
        this.lead_id.setValue(newData.id || "", false);
        // this.lead_action_id.setValue(newData.lead_action_id || "", false);
        // this.lead_interest_id.setValue(newData.lead_interest_id || "", false);
        // this.lead_status_id.setValue(newData.lead_status_id || "", false);
        // this.follow_up_date.setValue(newData.follow_up_date || "", false);
        // this.next_follow_up_date.setValue(
        //   newData.next_follow_up_date || "",
        //   false
        // );
        // this.synopsis_details.setValue(newData.synopsis_details || "", false);
      },
    },
  },
  created() {
    if (this.$store.getters.getHrmEmployeeList.length === 0) {
      this.$store.dispatch("getHrmEmployeeList");
    }
  },
  computed: {
    getHrmEmployeeList() {
      return this.$store.getters.getHrmEmployeeList;
    },
  },
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
  setup(props, { emit }) {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        employee_id: yup
          .array()
          .of(yup.number().positive().integer())
          .min(1, "At least one employee is required")
          .required()
          .label("Employees"),
      }),
    });
    const lead_id = useField("lead_id");
    const employee_id = useField("employee_id");
    const status = useField("status");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();

    const submit = handleSubmit((values) => {
      const submissionData = {
        employee_id: values.employee_id || [],
        status: parseInt(values.status) || 1,
      };
     
      const leadId = lead_id.value.value;

      store.dispatch("saveUpdateSalesLeadAssigned", {
        lead_id: leadId,
        employee_id: values.employee_id || [],
        status: parseInt(values.status) || 1,
      })
      .then((response) => {
        resetForm();
        emit("update:dialog", false);
        emit("update-success");
        toast.success(response.data.message);

        loading.value = true;
        store.dispatch("getSalesLeads").finally(() => {
          loading.value = false;
        });
      })
      ;
    });

    // const submit = handleSubmit((values) => {

    //   const formData = new FormData();
    //   Object.keys(values).forEach((key) => {
    //     if (key === "employee_id" && Array.isArray(values[key])) {
    //       formData.append("employee_id", (values[key]));
    //     } else {
    //       formData.append(key, values[key] || "");
    //     }
    //   });
    //   console.log("formData" , values);

    //   // ধরো lead_id তুমি props থেকে নিচ্ছো বা অন্য কোথাও থেকে আসছে
    //   const leadId = lead_id.value.value;
    //   console.log(leadId);

    //   store
    //     .dispatch("saveUpdateSalesLeadAssigned", { lead_id: leadId, formData })
    //     .then((response) => {
    //       resetForm();
    //       emit("update:dialog", false);
    //       emit("update-success");
    //       toast.success(response.data.message);

    //       loading.value = true;
    //       store.dispatch("getSalesLeads").finally(() => {
    //         loading.value = false;
    //       });
    //     })
    //     .catch((error) => {
    //       toast.error(error.response?.data?.message || "Something went wrong");
    //     });
    // });
    return {
      submit,
      lead_id,
      employee_id,
      errorMessages,
      resetForm,
      status,
      loading,
    };
  },
  mounted() {},
};
</script>
